import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { debounce } from 'lodash';
import { ActionService } from 'src/app/services/action/action.service';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
    selector: 'app-pb-header-notice-board',
    templateUrl: './pb-header-notice-board.component.html',
    styleUrls: ['./pb-header-notice-board.component.scss']
})
export class PbHeaderNoticeBoardComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    @Input() section: any = {};
    padding_top: any = '';
    padding_bottom: any = '';
    items: any = [];
    activeFilter: string = 'All';
    title: '';

    posts: any = [];
    loadedPosts: boolean = false;
    filters: any = [];
    unfilteredPosts = [];

    filterTag: any = false;

    constructor(private route: ActivatedRoute, private actionService: ActionService, private api: ApiService, private cd: ChangeDetectorRef) { }

    ngOnInit(): void {

        this.content.forEach(element => {
            var item = {
                content: element.data,
                alignment: this.determineAlignment(element.alignment),
                padding: this.determinePadding(element.padding),
                type: element.item.type
            }

            this.items.push(item);
        });

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

        this.filterByTitle = debounce(this.filterByTitle, 1000);

        this.route.queryParamMap.subscribe(params => {
            let tag = params.get("tag");

            if (tag) {
                this.filterTag = tag;
                this.filterPosts(this.filterTag);
            } else {
                this.filterTag = false;
            }
        });

        this.fetchPosts();

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment == 'LEFT') {
            return 'text-left';
        } else if (alignment == 'CENTER') {
            return 'text-center';
        } else if (alignment == 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding == 'SMALL') {
            return '10';
        } else if (padding == 'MEDIUM') {
            return '15';
        } else if (padding == 'LARGE') {
            return '30';
        } else if (padding == 'XLARGE') {
            return '60';
        }

    }

    /**
     * Fetches notice board posts
     * This will be used for initial fetching of posts and passing that to the parent component (notice-board)
     * and also the listing of the tags underneath the search bar
     */
    async fetchPosts() {

        await this.api.fetch_posts()
            .subscribe(res => {
                this.posts = res.data.items;

                let tempFilters = [];

                this.posts.forEach(element => {
                    let tags = [];

                    if (element.tagged.length > 0) {
                        element.tagged.forEach(subelement => {
                            tags.push(subelement.tag_name);
                            tempFilters.push(subelement.tag_name);
                        });
                    }

                    if (tags.length > 0) {
                        element.tag = tags[0]
                    } else {
                        element.tag = '';
                    }
                });

                this.filters = [...new Set(tempFilters)]; // Only get unique values       
                this.unfilteredPosts = this.posts;
                this.cd.detectChanges();

                if (this.filterTag) {
                    this.filterPosts(this.filterTag);
                } else {
                    this.actionService.setAction({
                        action: "fetch-posts",
                        data: JSON.stringify(this.posts)
                    });
                }
            }, (err) => {
                this.loadedPosts = true;
                this.cd.detectChanges();
            });

    }

    /**
     * Clicking on a tag will post that filter to the parent component to then call the filter posts by tag api function
     * @param value 
     */
    async filterPosts(value) {

        this.title = '';
        this.activeFilter = value;

        this.actionService.setAction({
            action: "filter-posts-by-tag",
            data: value
        });

    }

    /**
     * Typing a title will post that title to the parent component to then call the filter posts by title api function
     * @param value 
     */
    async filterByTitle() {

        this.activeFilter = 'All';

        this.actionService.setAction({
            action: "filter-posts-by-title",
            data: this.title
        });

    }

}
